const timeline = [
  {
    year: "2023",
    title: "Web Development Training",
    org: "ThemeAtelier",
    body: "Built a strong foundation in modern web development — HTML, CSS, JavaScript, Bootstrap, Tailwind CSS, Sass, WordPress, Git & GitHub. Learned to design and ship responsive, production-ready websites from scratch.",
    tags: ["HTML", "CSS", "JavaScript", "Bootstrap", "Tailwind", "Sass", "Git"],
  },
  {
    year: "2023 – Present",
    title: "Competitive Programming",
    org: "Phitron & Online Judges",
    body: "Deepened programming skills through structured training in C, C++, Data Structures, and Algorithms. Solved 500+ problems on Codeforces and CodeChef. Achieved a max rating of 1637 (3★) on CodeChef and Pupil on Codeforces through regular contest participation.",
    tags: ["C", "C++", "DSA", "Algorithms", "CodeChef", "Codeforces"],
  },
  {
    year: "2023 – Present",
    title: "Diploma in CSE",
    org: "Compact Polytechnic Institute, Feni",
    body: "Currently studying Diploma Engineering in Computer Science and Engineering. Expanding knowledge into Python and Java while continuously building practical projects. Passionate about applying theoretical knowledge to real-world engineering challenges.",
    tags: ["Python", "Java", "Computer Science", "Engineering"],
  },
];

const Experience = () => {
  return (
    <section className="section-padding experience" id="experience">
      <div className="container">
        {/* Section header */}
        <div
          className="text-center section-header"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <span className="sec-label">Experience</span>
          <h2 className="sec-title">My Learning Journey</h2>
          <div className="sec-line" />
        </div>

        {/* Timeline */}
        <div className="experience__timeline">
          {timeline.map((item, idx) => (
            <div
              key={idx}
              className="experience__item"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay={idx * 120}
            >
              <div className="experience__card">
                <div className="experience__card-top">
                  <h3 className="experience__card-title">{item.title}</h3>
                  <span className="experience__card-year">{item.year}</span>
                </div>
                <p className="experience__card-org">{item.org}</p>
                <p className="experience__card-body">{item.body}</p>
                <div className="experience__card-tags">
                  {item.tags.map((tag) => (
                    <span key={tag} className="experience__tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
